import React from 'react'
import { Button } from '@mui/material'
import { useToasts } from 'react-toast-notifications'
import { ApolloError } from '@apollo/client'
import { useMedicalReport } from './useMedicalReport'

export function MedicalReport({ uid }: { uid: string }) {
  const { exportMedicalReport, loading } = useMedicalReport(uid)
  const { addToast } = useToasts()

  return (
    <Button
      onClick={async () => {
        try {
          const { url, warning } = await exportMedicalReport()

          if (warning) {
            // This is a workaround to display the warning in a multi-line format
            addToast(<div style={{ whiteSpace: 'pre-line' }}>{warning}</div>, {
              appearance: 'warning',
              autoDismissTimeout: null,
            })
          }

          if (url) {
            if (process.env.NODE_ENV === 'development') {
              addToast(`Medical report generated successfully: ${url}`, {
                appearance: 'success',
                autoDismissTimeout: 5000,
              })
            } else {
              window.open(url, '_blank')
            }
          }
        } catch (error) {
          if (error instanceof ApolloError && error?.graphQLErrors[0]?.extensions?.clientError) {
            addToast(error.message, { appearance: 'error' })
          } else {
            addToast('Failed to generate medical report', { appearance: 'error' })
          }
        }
      }}
      disabled={loading}
      variant="outlined"
      size="small"
    >
      {loading ? 'Generating...' : 'Open Medical Report'}
    </Button>
  )
}
